/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const A = 400, N = 0;
export {
  A as DEFAULT_ANIMATION_DURATION,
  N as NO_ANIMATION
};
